import { signal } from 'services/SignalsService'
import { view } from 'settings/base'
import { Device } from 'utils/Device'

signal.on('LOGO-ANIM:START', resize)
signal.on('STATE:OUT:INIT', resize)
signal.on('SPLASH:BUILDED', resize)

export function resize() {
  const screen = {
    width: window.innerWidth,
    height: window.innerHeight,
  }
  const orientation = screen.width > screen.height ? 'land' : 'port'
  const stage = Device.isDesktop() ? view.desktop[orientation] : view.mobile[orientation]
  const scale = Math.min(screen.width / stage.width, screen.height / stage.height)

  const data = {
    orientation,
    scale,
    stage,
    screen,
  }

  signal.dispatch('RESIZE', data)
  signal.dispatch('DISPLACEMENT:BUTTON', { orientation })
}

function init() {
  window.onresize = resize
  window.addEventListener('orientationchange', resize)

}

export const ResizeService = { init, resize }
